import { useState } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import { Title as RaTitle } from "react-admin";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import { STAGES, STAGE_ORDER } from "./stages";
import PendingList from "./PendingList";

const DoctoralSeatApprovalsPage = () => {
  const userPermissions = getPermissions();

  const visibleStages = STAGE_ORDER.filter(key =>
    checkPermission(userPermissions, STAGES[key].permission),
  );

  const [activeKey, setActiveKey] = useState(visibleStages[0] ?? null);

  if (!activeKey) {
    return (
      <>
        <RaTitle title="Одобрение на докторантски места" />
        <Paper sx={{ p: 4, mt: 2 }}>
          <Typography align="center" color="text.secondary">
            Нямате права за одобрение на докторантски места.
          </Typography>
        </Paper>
      </>
    );
  }

  return (
    <>
      <RaTitle title="Одобрение на докторантски места" />
      <Paper sx={{ mt: 2 }}>
        <Tabs
          value={activeKey}
          onChange={(_, v) => setActiveKey(v)}
          indicatorColor="primary"
          textColor="primary"
        >
          {visibleStages.map(key => (
            <Tab key={key} value={key} label={STAGES[key].label} />
          ))}
        </Tabs>
        <Box sx={{ p: 2 }}>
          <PendingList stage={STAGES[activeKey]} />
        </Box>
      </Paper>
    </>
  );
};

export default DoctoralSeatApprovalsPage;
